import Page from './Page/Page';

export default Page;
